import React, { useEffect, useState } from "react";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemSearchResult from "../../../models/ItemSearchResult";
import DataService from "../../../services/data.service";
import { LicensePopupProps } from "../../../types/PopupProps";
import ItemSearchMiniView from "../../Search/ItemMini";

interface LicenseItemModel {
    licenseId: number
    itemId: number
    included: boolean
    excluded: boolean
}

const AddLicenseItemPopup: React.FC<LicensePopupProps> = ({ show, onHide, licenseId, included }) => {
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<LicenseItemModel>({
        licenseId: licenseId,
        itemId: 0,
        included: included,
        excluded: !included
    });

    useEffect(() => {
        formData.included = included;
        formData.excluded = !included;
        setFormData(formData);

    }, [included]);

    function handleItemClicked(itemRevision: ItemSearchResult) {
        formData.itemId = itemRevision.itemId;

        DataService
            .create<LicenseItemModel>(`api/v1/LicenseItems`, formData)
            .then(response => {
                handleResult(response);
                if (response.isSuccesful === true) {
                    if (onHide)
                        onHide();
                }
            })
            .catch(e => handleException(e));
    }

    return (
        <Popup show={show} onHide={onHide} size={'xxl'} title={included ? 'Include item in License' : 'Exclude item from License'}>
            <Popup.Body>
                <ItemSearchMiniView handleItemClicked={handleItemClicked} forBom={false} />
            </Popup.Body>
        </Popup>
    );
}
export default AddLicenseItemPopup;